import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { SharedHttpService } from '../../services/shared-http.service';

@Component({
  selector: 'app-violation-details',
  templateUrl: './violation-details.component.html',
  styleUrls: ['./violation-details.component.scss']
})
export class ViolationDetailsComponent implements OnInit {

    ViolationDetails: any;
    ViolationInfo: any;
    ViolationPenalties: any;
    ViolationAttachments: any;
    ViolationObjections: any;
    
    doc: any = "";
    pdfFile = false;
    image: any;


    constructor(private sanitizer: DomSanitizer, private sharedService: SharedHttpService) {

    }
    @Input() loadDataFP: Observable<any>;


    ngOnInit(): void {
        this.loadDataFP.subscribe((data) => {
            this.ViolationDetails = data.ViolationDetails;

            this.ViolationInfo = this.ViolationDetails.violation;
            this.ViolationPenalties = this.ViolationDetails.penalties;
            this.ViolationAttachments = this.ViolationDetails.violationAttachments;
            this.ViolationObjections = this.ViolationDetails.objections; 

        });

    }


    downloadFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.mimeType });
        var url = window.URL.createObjectURL(blob);

        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = attachment.fileName;
        fileLink.click();
    }
    download(attachment) {
        let url = `api/Violation/DownloadViolationFile?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.downloadFile(data, attachment);
        });
    }
    previewPDF(attach, pdfmodal) {

        this.sharedService.openLarge(pdfmodal);
        this.show(attach);
    }



    show(attachment) {
        let url = `api/Violation/DownloadViolationFile?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.ShowFile(data, attachment);
        });
    }
    ShowFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.fileType });
        var url = window.URL.createObjectURL(blob);
        this.doc = url;
        if (attachment.fileName.endsWith('.pdf')) {
            this.pdfFile = true;
        } else {
            this.pdfFile = false;
            this.image = this.sanitizer.bypassSecurityTrustUrl(url)
        }
    }







}
